
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/home/bitrock/ruby27stack/apps/canvaslms/htdocs/ui/shared/outcome-content-view/jst/MoveOutcomeDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div>\n  <form class='form-dialog'>\n    <div class='form-dialog-content'>\n    </div>\n    <div class='form-controls'>\n      <input type='button' class='btn' value='Cancel'>\n      <input type='submit' class='btn btn-primary' value='Move'>\n    </div>\n  <form>\n</div>";
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';
    brandableCss.loadStylesheet('jst/MoveOutcomeDialog', {"new_styles_normal_contrast":{"combinedChecksum":"9d1c3f4686"},"new_styles_high_contrast":{"combinedChecksum":"9d1c3f4686"},"responsive_layout_normal_contrast":{"combinedChecksum":"9d1c3f4686"},"responsive_layout_high_contrast":{"combinedChecksum":"9d1c3f4686"},"new_styles_normal_contrast_rtl":{"combinedChecksum":"9d1c3f4686"},"new_styles_high_contrast_rtl":{"combinedChecksum":"9d1c3f4686"},"responsive_layout_normal_contrast_rtl":{"combinedChecksum":"9d1c3f4686"},"responsive_layout_high_contrast_rtl":{"combinedChecksum":"9d1c3f4686"}}[brandableCss.getCssVariant()]);
  ;
    export default templates[name];
  